// extracted by mini-css-extract-plugin
export default {"footer":"LoginFooter_footer__QWgLX","warp":"LoginFooter_warp__tyr3M","square":"LoginFooter_square__Tmb5h"};